import { DefualtAPIMessageResponse } from "types/api";

import { axiosBaseQuery } from "@picovico/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export interface ContactUsPayload {
  full_name: string;
  phone: string;
  message: string;
  extra_fields?: Record<string, string>;
}

export const contactApi = createApi({
  reducerPath: "contactApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    submitContactUs: builder.mutation<
      DefualtAPIMessageResponse,
      ContactUsPayload
    >({
      query: (data) => ({
        name: "contact_us",
        method: "POST",
        data,
      }),
    }),
  }),
});

export const { useSubmitContactUsMutation } = contactApi;
